import React from 'react'
import { graphql, gql } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'

import { translate } from 'react-i18next'

import { CURRENCIES, DEFAULT_CURRENCY, PLANNING_SERVICES } from '../../../constants'

import { Form, TextInput, SelectInput, TextAreaInput } from '../../UI'
import Loader from '../../UI/Loader'
import { NotificationManager } from 'react-notifications'

import { validateRequired } from '../../../libs/validation'
import USER_QUERY from './../../../graphql/UserByID.graphql'
import get from 'lodash/get'


class ServicesForm extends React.Component {
  state = {
    saving: false,
    selectedServices: [],
    items: [
      {
        id: _.uniqueId(),
        price: 0,
        service: '',
        description: ''
      }
    ],
    currency: DEFAULT_CURRENCY,
    error: '',
    routeIndex: 10
  }

  componentWillMount() {
    const services = _.get(this, 'props.data.User.plannerProfile.serviceOffers', [])
    const currency = _.get(this, 'props.data.User.plannerProfile.currency', DEFAULT_CURRENCY)
    if (services && services.length) {
      const items = services.map(planningService => {
        return {
          id: _.uniqueId(),
          price: planningService.price,
          service: planningService.service,
          description: planningService.description
        }
      })
      this.setState({ items, currency })
    }
  }

  componentWillReceiveProps(nextProps) {
    const services = _.get(this, 'props.data.User.plannerProfile.serviceOffers', [])
    const servicesNext = _.get(nextProps, 'data.User.plannerProfile.serviceOffers', [])
    const currency = _.get(nextProps, 'data.User.plannerProfile.currency', DEFAULT_CURRENCY)
    if (services && servicesNext && services.length !== servicesNext.length) {
      const items = servicesNext.map(planningService => {
        return {
          id: _.uniqueId(),
          price: planningService.price,
          service: planningService.service,
          description: planningService.description
        }
      })
      this.setState({ items, currency })
    }
  }

  handleSubmit = values => {
    this.props.validate(this.state.routeIndex, true)
    this.setState({
      saving: true,
      error: ''
    })
    const { t } = this.props
    const { plannerProfile } = this.props.data.User
    const services = []
    let currency
    for (let item in values) {
      let index = item.indexOf('_')
      let nextId = item.slice(index + 1)
      if (values.hasOwnProperty(item) && values[item] && item.startsWith('service_')) {
        if (services.findIndex(planningService => planningService.service === values[item]) !== -1) {
          this.setState({
            saving: false,
            error: t('duplicate_services_error')
          })
          return
        }
        currency = values['currency_' + nextId]
        services.push({
          plannerProfile: plannerProfile.id,
          service: values[item],
          price: +values['price_' + nextId],
          description: values[`description_${nextId}`]
        })
      }
    }
    const deletePromises = plannerProfile.serviceOffers.map(service => {
      return this.props.deleteServiceOffer({
        variables: {
          id: service.id
        }
      })
    })
    Promise.all(deletePromises)
      .then(() => {
        const createPromises = services.map(service => {
          console.log('')
          return this.props.createServiceOffer({
            variables: service
          })
        })
        return Promise.all([
          ...createPromises,
          this.props.updatePlannerProfile({
            variables: {
              id: plannerProfile.id,
              currency: currency
            }
          })
        ])
      })
      .then(() => {
        this.props.data.refetch()
        NotificationManager.success('Additional services updated', 'Success', 5000)
        this.setState(
          () => ({
            saving: false
          }),
          () => {
            this.props.history.push('/create-guru-profile/pay-pal')
          }
        )
      })
      .catch(err => {
        this.setState(() => ({
          saving: false
        }))

        NotificationManager.error('Error while updating additional services', 'Error', 5000)
      })
  }

  handleAddClick = () => {
    this.setState({
      items: [
        ...this.state.items,
        {
          id: _.uniqueId(),
          price: 0,
          service: '',
          description: ''
        }
      ]
    })
  }

  handleRemoveClick = id => {
    const items = this.state.items.filter(item => item.id !== id)
    this.setState({ items })
  }

  handleCurrencyChange = (id, value) => {
    this.setState({
      currency: value
    })
    for (let el in this) {
      if (this.hasOwnProperty(el) && el.slice(0, 9) === 'currency_' && this[el]) {
        this[el].overrideValue(value)
      }
    }
  }

  getCurrencyOptions = () => {
    const options = []
    for (let currency in CURRENCIES) {
      if (CURRENCIES.hasOwnProperty(currency)) {
        options.push({
          label: CURRENCIES[currency],
          value: currency
        })
      }
    }
    return options
  }

  handleServicesChange = (id, value) => {
    console.log('handleServicesChange', id, value)
    this.setState(
      {
        selectedServices: [...this.state.selectedServices, value]
      },
      () => console.log('update select', this.state.selectedServices)
    )
  }

  getServiceOptions = () => {
    const { t } = this.props
    const options = []

    for (let service in PLANNING_SERVICES) {
      if (PLANNING_SERVICES.hasOwnProperty(service)) {
        options.push({
          value: service,
          label: t('booking_steps:' + service)
        })
      }
    }
    return options
  }

  render() {
    if (this.props.data.loading) {
      return <Loader showLoader={true} />
    }
    const { t } = this.props
    const { saving, items, currency } = this.state

    return (
      <div className="steps-screen__form faded-container">
        <div className="steps-screen__form-title">{t('additional_services_title')}</div>
        <div className="steps-screen__form-subtitle">{t('additional_services_message')}</div>
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger"
          submitBtnName={t('main:save_continue')}
          submittingToServer={saving}
        >
          <div className="steps-screen__form-input-area">
            <div>
              {items.map(el => {
                console.log('el', el)
                return (
                  <div key={el.id} className="removable-item-row">
                    <div>
                      <div className="row">
                        <div className="col-sm-12">
                          <SelectInput
                            options={this.getServiceOptions()}
                            id={`service_${el.id}`}
                            onChangeExternal={this.handleServicesChange}
                            placeholder={t('additional_services_placeholder')}
                            initialValue={el.service}
                            validationFuncs={[validateRequired]}
                            simpleValue
                            label={t('additional_services_title')}
                            labelClass="steps-screen__form-input-label"
                            clearable={false}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <TextInput
                            id={`price_${el.id}`}
                            placeholder={t('main:enter_price')}
                            initialValue={'' + el.price}
                            validationFuncs={[validateRequired]}
                            label={t('main:price')}
                            labelClass="steps-screen__form-input-label"
                            isGroup={true}
                          />
                        </div>
                        <div className="col-sm-6">
                          <SelectInput
                            ref={sel => {
                              this[`currency_${el.id}`] = sel
                            }}
                            options={this.getCurrencyOptions()}
                            id={`currency_${el.id}`}
                            placeholder={t('main:select_currency')}
                            initialValue={currency}
                            validationFuncs={[validateRequired]}
                            simpleValue
                            onChangeExternal={this.handleCurrencyChange}
                            label={t('main:currency')}
                            labelClass="steps-screen__form-input-label"
                            clearable={false}
                            isGroup={true}
                          />
                        </div>
                      </div>
                      <div className="col-sm-12" style={{ padding: 0, marginBottom: '25px' }}>
                        <TextAreaInput
                          id={`description_${el.id}`}
                          label={'Description'}
                          labelClass="steps-screen__form-input-label"
                          placeholder={'Description'}
                          rows={5}
                          maxChars={300}
                          initialValue={el.description ? el.description : ''}
                          isGroup={true}
                        />
                      </div>
                    </div>
                    {items.length > 1 && (
                      <div className="remove-item-link" onClick={() => this.handleRemoveClick(el.id)}>
                        <span className="icon-cancel" /> {t('main:remove')}
                      </div>
                    )}
                  </div>
                )
              })}
              {this.state.error && <small className="text-danger">{this.state.error}</small>}
            </div>
            <div className="add-item-link" onClick={this.handleAddClick}>
              <span className="icon-plus" /> {t('add_service')} (optional)
            </div>
          </div>
        </Form>
      </div>
    )
  }
}

const deleteServiceOffer = gql`
  mutation($id: ID!) {
    deleteServiceOffer(id: $id) {
      id
    }
  }
`

const createServiceOffer = gql`
  mutation($plannerProfile: ID, $price: Int!, $service: PlanningServices!, $description: String) {
    createServiceOffer(plannerProfileId: $plannerProfile, price: $price, service: $service, description: $description) {
      id
    }
  }
`

const updatePlannerProfile = gql`
  mutation($id: ID!, $currency: String!) {
    updatePlannerProfile(id: $id, currency: $currency) {
      id
    }
  }
`

const TranslatedServicesForm = translate('guru')(ServicesForm)

export default graphql(deleteServiceOffer, {
  name: 'deleteServiceOffer'
})(
  graphql(updatePlannerProfile, {
    name: 'updatePlannerProfile'
  })(
    graphql(createServiceOffer, {
      name: 'createServiceOffer'
    })(
      graphql(USER_QUERY, {
        options: props => ({
          variables: {
            id: get(props, 'user.id', '')
          },
          options: {
            fetchPolicy: 'network-only'
          }
        })   
      })
      (withRouter(TranslatedServicesForm))
    )
  )
)



// WEBPACK FOOTER //
// src/components/Guru/CreateGuruProfile/ServicesForm.jsx